export default __webpack_public_path__ + "static/media/extra_mile_logo_1_10.027e92f0.png";